(() => {
  const script = document.querySelector('[data-judge-me-review-dates]');
  const productId = script?.dataset.productId;

  if (!productId) return;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const dateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const addReviewDates = () => {
    const reviewData = window.jdgm?.data?.reviewWidget?.[productId];
    const reviews = reviewData?.reviews;

    if (!Array.isArray(reviews)) return;

    document.querySelectorAll('.jm-review-item').forEach((reviewItem) => {
      if (reviewItem.querySelector('.cb-judge-me-review-date')) return;

      const reviewerName = normalize(reviewItem.querySelector('.jm-reviewer-info__name')?.textContent);
      const reviewTitle = normalize(reviewItem.querySelector('.jm-review-content__title')?.textContent);
      const reviewBody = normalize(reviewItem.querySelector('.jdgm-review-content__body-content')?.textContent);
      const review = reviews.find(
        (item) =>
          normalize(item.reviewer_name) === reviewerName &&
          normalize(item.title) === reviewTitle &&
          normalize(item.body) === reviewBody
      );

      if (!review?.created_at) return;

      const details = reviewItem.querySelector('.jm-reviewer-info__details');
      const date = new Date(review.created_at);

      if (!details || Number.isNaN(date.getTime())) return;

      const time = document.createElement('time');
      time.className = 'cb-judge-me-review-date';
      time.dateTime = review.created_at;
      time.textContent = dateFormatter.format(date);
      details.append(time);
    });
  };

  let updateScheduled = false;
  const scheduleUpdate = () => {
    if (updateScheduled) return;

    updateScheduled = true;
    requestAnimationFrame(() => {
      updateScheduled = false;
      addReviewDates();
    });
  };

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { childList: true, subtree: true });
  scheduleUpdate();
})();
